// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import App from './App';
// import { BrowserRouter } from 'react-router-dom';
// import "../src/assets/css/style.css";
// import "../src/assets/css/responsive.css";
// import "../src/assets/css/demo-1.css";
// import "../src/assets/css/vendor/gicons.css";
// import "../src/assets/css/vendor/gicons.css";
// import "../src/assets/css/plugins/animate.css";
// import "../src/assets/css/plugins/nouislider.css";
// import "../src/assets/css/plugins/owl.carousel.min.css";
// import "../src/assets/css/plugins/owl.theme.default.min.css";
// import "../src/assets/css/plugins/slick.min.css";
// import "../src/assets/css/plugins/swiper-bundle.min.css";
// import '@fontsource/poppins'; // Defaults to weight 400
// import '@fontsource/poppins/400.css'; // Explicitly import weights as needed
// import '@fontsource/poppins/700.css'; // Example for bold weights
// import './firebase/Firebase'; 

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <BrowserRouter>
//     <App />
//     </BrowserRouter>
//   </React.StrictMode>
// );


import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// import "./config/i18n";
import { BrowserRouter } from "react-router-dom";
import "../src/assets/css/style.css";
import "../src/assets/css/responsive.css";
import "../src/assets/css/demo-1.css";
// import "../src/assets/css/vendor/gicons.css";
import "../src/assets/css/vendor/gicons.css";
import "../src/assets/css/plugins/animate.css";
import "../src/assets/css/plugins/nouislider.css";
import "../src/assets/css/plugins/owl.carousel.min.css";
import "../src/assets/css/plugins/owl.theme.default.min.css";
import "../src/assets/css/plugins/slick.min.css";
import "../src/assets/css/plugins/swiper-bundle.min.css";
import '@fontsource/poppins';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/700.css';
import { requestPermission, messaging } from './firebase/Firebase';
import { onMessage } from "firebase/messaging";
import { toast } from "react-toastify";

const RootComponent = () => {
  // Register Service Worker first, then request FCM permission
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          console.log("✅ Service Worker registered:", registration);
          // Call requestPermission only after SW is registered
          requestPermission();
        })
        .catch((error) => {
          console.error("❌ Service Worker registration failed:", error);
        });
    }
  }, []);

  // Listen for foreground Firebase Cloud Messaging notifications
  useEffect(() => {
    console.log("📡 Registering Firebase foreground message listener...");
    try {
      const unsubscribe = onMessage(messaging, (payload) => {
        console.log("⚡ [Firebase Foreground Message] Received payload:", payload);

        const title = payload?.notification?.title || "Notification Received";
        const body = payload?.notification?.body || "";

        toast.info(
          <div>
            <strong style={{ display: "block", marginBottom: "4px" }}>🔔 {title}</strong>
            <span>{body}</span>
          </div>,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      });
      return () => {
        console.log("🔌 Unsubscribing Firebase foreground message listener");
        unsubscribe();
      };
    } catch (err) {
      console.error("❌ Error setting up foreground message listener:", err);
    }
  }, []);


  return (
    // <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    // </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RootComponent />);
